/**
 * Parses a JSON Web Token (JWT) and returns its payload.
 *
 * @param token The JWT to be parsed.
 * @returns The payload of the JWT.
 */
export const parseJwt = (token: string) => {
  /**
   * The base64Url-encoded payload of the JWT.
   */
  const base64Url = token.split('.')[1];

  /**
   * The base64-encoded payload of the JWT, with URL-safe characters replaced.
   */
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  /**
   * The decoded and URI-encoded payload of the JWT.
   */
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  /**
   * The parsed payload of the JWT.
   */
  const parsedToken = JSON.parse(jsonPayload);

  // Parse the "custom:proPermissions" field if it exists
  if (parsedToken['custom:proPermissions']) {
    parsedToken['custom:proPermissions'] = JSON.parse(
      parsedToken['custom:proPermissions'],
    );
  }

  return parsedToken;
};
